module.exports = __webpack_public_path__ + "media/images/home/market-place-bg-40a48fc8b56ec717cf14de22977f77b9.jpg";